module.exports = __webpack_public_path__ + "img/predus.1d1ba6a4.png";